<template>
  <div class="conditions-aide">
    <ul>
      <li v-for="(condition, index) in conditions"
        :key="'cond' + index">
        {{ condition.libelle }}
      </li>
    </ul>
    <div v-if="groups.length">
      <ul v-for="(group, index) in groups"
          :key="'group' + index">
        <li>
          {{ group.libelle }}
        </li>
        <li class="sub-condition">
          <ul :class="{ 'or-condition': group.type === 'OU' }">
            <li v-for="(condition, indexCond) in group.conditions"
                :key="'groupCond' + indexCond">
              {{ condition.libelle }}
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConditionsAide',
  props: {
    conditions: {
      type: Array,
      required: true
    },
    groups: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss">
.conditions-aide {
  ul {
    font-family: $secondary-font;
    font-size: $text-size;
    padding-left: 80px;
    li {
      margin: 20px 0;
      font-size: $text-size-md;
      &.sub-condition {
        list-style-type: none;
        ul {
          padding-left: 20px;
        }
        .or-condition {
          li {
            position: relative;
            margin: 25px;
            &:first-child {
              margin-top: 20px;
            }
            &:not(:first-child):before {
              content: 'OU';
              position: absolute;
              left: -22px;
              top: -23px;
              font-weight: 700;
              font-size: 0.7rem;
            }
          }
        }
      }
    }
  }
}
</style>
